import Post2 from './Post2'
export default Post2
